module.exports = __webpack_public_path__ + "static/img/47252554-9e81-425e-87b1-d9a96255a446.2450b97.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/47252554-9e81-425e-87b1-d9a96255a446.png
// module id = wITw
// module chunks = 1